import { Injectable } from '@angular/core';
import { ToraxHttp } from '../utils/custom-http.svc';

@Injectable()
export class QuickBooksSyncAdminData {
  constructor(private toraxHttp: ToraxHttp) { }

  start(request: any) {
    return this.toraxHttp.postWithResponce('api/QuickBooksSync/triggerSyncAllContacts', request);
  }

  getStatus(requestId: string) {
    return this.toraxHttp.get(`api/QuickBooksSync/status/${requestId}`);
  }

  getActive() {
    return this.toraxHttp.get('api/QuickBooksSync/activeGlobalSync');
  }

  control(requestId: string, command: string) {
    return this.toraxHttp.postWithResponce(`api/QuickBooksSync/control/${requestId}`, { command });
  }
}
